import Section from './WorkOrderBlock'
import isEmpty from './WorkOrderIsEmpty'

export default { isEmpty, Section }
